module.exports = __webpack_public_path__ + "img/ic_tick.b857779e.svg";